import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { PusherContext } from 'src/app/App'
import { selectPusherChannelPrefix } from 'src/redux/selectors/session.selectors'

const usePusher = (
  userId?: string,
): {
  bind: (
    eventName: string,
    callback: (data: { id: string; action: string }) => void,
  ) => void
} => {
  const pusherChannelPrefix = useSelector(selectPusherChannelPrefix)
  const pusher = useContext(PusherContext)

  const bind = (
    eventName: string,
    callback: (data: { id: string; action: string }) => void,
  ): void =>
    useEffect(() => {
      if (!pusher) {
        return
      }
      const channel = pusher.subscribe(`${pusherChannelPrefix}${userId}`)
      channel.bind(eventName, callback)

      return (): void => {
        pusher.disconnect()
      }
    }, [pusher])

  return { bind }
}

export default usePusher
